<div class="gpt41-dialog">
  <button
    class="close-btn"
    mat-icon-button
    (click)="close()"
    aria-label="Close ChatGPT 4.1 Info">
    <span aria-hidden="true"><i class="fas fa-bars"></i></span>
  </button>

  <div class="header">
    <img src="assets/metabrain.jpeg" alt="ChatGPT 4.1 Logo" class="logo" />
    <h2>ChatGPT 4.1</h2>
    <div class="sub">OpenAI’s Advanced, Versatile, High-Capacity Model</div>
  </div>

  <div class="body">
    <p>
      <strong>ChatGPT 4.1</strong> is the latest flagship model from OpenAI, delivering exceptional accuracy, nuanced understanding, and reliable performance across the broadest range of topics. It’s engineered for demanding business, research, and creative use cases, excelling at advanced reasoning, technical tasks, and multi-turn dialog.
    </p>

    <ul>
      <li>🧠 <strong>Superb Reasoning:</strong> Handles complex instructions, context, and multi-step logic like never before.</li>
      <li>🔬 <strong>Reliable Expertise:</strong> Ideal for technical content, research, data analysis, and high-value communication.</li>
      <li>🎨 <strong>Creative & Flexible:</strong> Excels at ideation, storytelling, summarization, and content generation.</li>
      <li>⚡ <strong>Consistent Performance:</strong> Manages lengthy conversations and high data volumes smoothly.</li>
      <li>🔒 <strong>Enhanced Safety:</strong> Industry-leading alignment, moderation, and factual accuracy.</li>
    </ul>

    <div class="optimal">
      <h3>Reasoning controls</h3>
      <ul>
        <li><strong>Auto:</strong> adapts depth to the request.</li>
        <li><strong>Instant:</strong> lightweight reasoning for speed.</li>
        <li><strong>Thinking:</strong> balanced depth for analysis and planning.</li>
        <li><strong>Pro:</strong> highest reasoning depth for complex tasks.</li>
      </ul>
    </div>

    <div class="optimal">
      <h3>When is ChatGPT 4.1 optimal?</h3>
      <ul>
        <li>✔️ For business automation, analytics, and mission-critical workflows</li>
        <li>✔️ When accuracy and reliability are top priorities</li>
        <li>✔️ For research, technical writing, code, and in-depth questions</li>
        <li>✔️ For creative professionals needing best-in-class AI output</li>
        <li>✔️ When you want the very latest capabilities OpenAI offers</li>
      </ul>
    </div>
  </div>
</div>
